<script>
import {
  permissionTemplateDelete,
  permissionTemplatePage,
  permissionTemplateSave,
  permissionTemplateUpdate
} from "@/api/user";
import {Message} from "element-ui";

export default {
  name: 'AgentTemplate',
  props: {
    roleId : {
      type: String |  Number,
      default: null
    }
  },
  data() {
    return {
      type : 'REGION',
      templates : [],
      currentPage : 1,
      pageSize : 20,
      total : 0,
      visible : false,
      templateForm : {},

    }
  },
  mounted() {
    this.fetchTemplates()
  },
  methods: {
    async refreshTemplate() {
      this.currentPage = 1;
      this.templates = []
      await this.fetchTemplates()
    },

    async fetchTemplates() {
      const param = {
        current: this.currentPage,
        size: this.pageSize,
        filter: [{
          name: 'type',
          type: 'EQ',
          value: this.type
        }],
        sorted: [{
          name: 'createTime',
          type: 'DESC'
        }]
      }
      const res = await permissionTemplatePage(param);
      if (res && res.code === '0000'){
        this.templates = res.result.records || [];
        this.total = res.result.total;
      }
    },


    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchPermissionList()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchPermissionList()
    },

    handleEdit(data){
      this.visible =  true;
      this.templateForm = {
        ...data
      }
    },

    async onSubmit (){
      const param = {
        ...this.templateForm,
        roleId : this.roleId
      }
      console.log('add' ,param)
      let res ;
      if (param.id){
        res = await permissionTemplateUpdate(param);
      }else {
        res = await permissionTemplateSave(param);
      }
      if (res && res.code === '0000'){
        Message.success(`操作成功`);
        this.visible = false;
        await this.refreshTemplate();
      }
    },

    async deleteTemplate(id) {
      this.$confirm('此操作将永久删除该权限模版, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const res = permissionTemplateDelete(id);
        if (res && res.code === '0000'){
          Message.success(`操作成功`);
          this.refreshTemplate();
        }
      }).catch(() => {

      });
    }
  }
}

</script>

<template>
  <div style="display: flex;flex-direction: column; gap: 10px;padding: 20px;box-sizing: border-box;flex: 1">
    <el-row :gutter="20" type="flex" justify="space-between" align="center">
      <el-radio-group v-model="type" @change="refreshTemplate" size="medium">
        <el-radio label="REGION">地域</el-radio>
        <el-radio label="CATEGORY">设备分类</el-radio>
        <el-radio label="EQUIPMENT">设备</el-radio>
      </el-radio-group>

      <el-button type="primary" size="small" @click="visible = true">新增</el-button>
    </el-row>
    <el-table :data="templates" border stripe highlight-current-row row-key="id">
      <el-table-column prop="tableName" label="表名" min-width="80" show-overflow-tooltip/>
      <el-table-column prop="tableColumn" label="列名" min-width="80" show-overflow-tooltip/>
      <el-table-column label="操作" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="handleEdit(scope.row)">
            编辑
          </el-button>
          <el-button size="mini" type="text" style="color: red" @click="deleteTemplate(scope.row.id)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper" :total="total"
                     class="pagination"></el-pagination>
    </div>

    <el-dialog title="新增权限模版" :visible.sync="visible" width="60%">
      <el-form v-model="templateForm" label-width="120px" >
        <el-form-item prop="id" hidden />
        <el-form-item required label="模版类型">
          <el-radio-group v-model="templateForm.type">
            <el-radio label="REGION">地域</el-radio>
            <el-radio label="CATEGORY">设备分类</el-radio>
            <el-radio label="EQUIPMENT">设备</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="表名" required>
          <el-input v-model="templateForm.tableName" />
        </el-form-item>

        <el-form-item label="字段名" required >
          <el-input v-model="templateForm.tableColumn" />
        </el-form-item>
        <el-form-item size="large">
          <el-button type="primary" @click="onSubmit">立即创建</el-button>
          <el-button @click="visible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>

</template>

<style scoped>

</style>
